import React from 'react';
import { Facebook, Twitter, Instagram, Mail } from 'lucide-react';
import VatNotice from './VatNotice';

const Footer = () => {
  return (
    <footer className="bg-black text-white">
      <div className="max-w-[1400px] mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-xl font-semibold mb-4">Zebra One Gallery</h3>
            <p className="text-gray-400 text-sm mb-4">
              Contemporary Art London since 1976
            </p>
            <div className="flex gap-3">
              <a href="https://www.facebook.com/zebraonegallery" target="_blank" rel="noopener noreferrer" className="hover:text-gray-400 transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="https://twitter.com/zebra1gallery" target="_blank" rel="noopener noreferrer" className="hover:text-gray-400 transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="https://www.instagram.com/zebraonegallery/" target="_blank" rel="noopener noreferrer" className="hover:text-gray-400 transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="mailto:info@zebraonegallery.com" className="hover:text-gray-400 transition-colors">
                <Mail className="w-5 h-5" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Navigation</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="/" className="hover:text-white transition-colors">Home</a></li>
              <li><a href="/shop" className="hover:text-white transition-colors">Shop</a></li>
              <li><a href="/artists" className="hover:text-white transition-colors">Artists</a></li>
              <li><a href="/exhibitions" className="hover:text-white transition-colors">Exhibitions</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Services</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="/art-consultation" className="hover:text-white transition-colors">Art Consultation</a></li>
              <li><a href="/picture-framing" className="hover:text-white transition-colors">Picture Framing</a></li>
              <li><a href="/about" className="hover:text-white transition-colors">About Us</a></li>
              <li><a href="/contact" className="hover:text-white transition-colors">Contact</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Contact Us</h4>
            <address className="text-sm text-gray-400 not-italic space-y-2">
              <p>73a Hampstead High Street</p>
              <p>Hampstead, London NW3 1QX</p>
              <p className="pt-2">Tel: <a href="tel:02077941281" className="hover:text-white">020 7794 1281</a></p>
              <p>Email: <a href="mailto:info@zebraonegallery.com" className="hover:text-white">info@zebraonegallery.com</a></p>
            </address>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 mb-6">
          <VatNotice variant="footer" />
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
          <p data-testid="footer-copyright">
            &copy; {new Date().getFullYear()} Zebra One Gallery. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="/pricing-vat" className="hover:text-white transition-colors">Pricing &amp; VAT</a>
            <a href="/shipping" className="hover:text-white transition-colors" data-testid="footer-shipping-link">Shipping &amp; Delivery</a>
            <a href="/privacy" className="hover:text-white transition-colors" data-testid="footer-privacy-link">Privacy Policy</a>
            <a href="/cookies" className="hover:text-white transition-colors" data-testid="footer-cookies-link">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
